var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-text"},[(_vm.content.title)?_c('BaseTitle',{staticClass:"simple-text__title",attrs:{"tag":"h2"}},[_vm._v(_vm._s(_vm.content.title))]):_vm._e(),(_vm.content.wysiwyg)?_c('BaseWysiwyg',{staticClass:"simple-text__content",attrs:{"content":_vm.content.wysiwyg}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }